import React, { useEffect } from 'react';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import confirm from 'antd/es/modal/confirm';
import dayjs from 'dayjs';
import { CalendarEvent, useCreateCalendarEventMutation } from 'entities/calendar';

type FormValues = Omit<CalendarEvent, 'id' | 'startDate' | 'endDate'> & {
  dateRange: [dayjs.Dayjs, dayjs.Dayjs];
};

interface CreateCalendarEventFormProps {
  datePeriod: dayjs.Dayjs[];
  form: FormInstance<FormValues>;
  instance: ReturnType<typeof confirm>;
  dom: React.ReactNode;
  calendarId: string;
}

const CreateCalendarEventForm: React.FC<CreateCalendarEventFormProps> = ({
  datePeriod,
  form,
  instance,
  dom,
  calendarId,
}) => {
  const { mutateAsync: createEventMutation } = useCreateCalendarEventMutation(calendarId);

  useEffect(() => {
    form.setFieldsValue({ dateRange: datePeriod });
  }, [datePeriod, form]);

  return (
    <Form
      initialValues={{
        dateRange: datePeriod,
        exclusionType: 'NON_WORKING_DAY',
      }}
      form={form}
      layout="vertical"
      requiredMark={false}
      autoComplete="off"
      data-testid="update-form"
      onFinish={(formData) => {
        const { dateRange, name, exclusionType, workingHours } = formData;
        const sendedData =
          exclusionType === 'NON_WORKING_DAY'
            ? {
                startDate: dateRange[0].format('YYYY-MM-DD'),
                endDate: dateRange[1].format('YYYY-MM-DD'),
                name: name.trim(),
                exclusionType,
              }
            : {
                startDate: dateRange[0].format('YYYY-MM-DD'),
                endDate: dateRange[1].format('YYYY-MM-DD'),
                name: name.trim(),
                exclusionType,
                workingHours,
              };

        instance.update({ okButtonProps: { loading: true } });
        createEventMutation(sendedData, {
          onSettled: () => instance.destroy(),
          onError: () => instance.update({ okButtonProps: { loading: false } }),
        });
      }}
    >
      {dom}
    </Form>
  );
};

export { CreateCalendarEventForm };
